import {
  Button,
  TextField,
  Container,
  List,
  ListItem,
  Typography,
  Box,
  IconButton,
  InputAdornment,
  Link,
  CardContent,
  Card,
} from "@mui/material";
import { Email, Lock } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import React, { FormEventHandler, useState, ChangeEventHandler } from "react";
import { CreateUserRequest, useCreateUserMutation } from "../apis/users";
import LogoIcon from "../components/LogoIcon";

const Signup = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState<CreateUserRequest>({ name: "", email: "", password: "" });
  const [createUser, { isLoading }] = useCreateUserMutation();

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const { email, name, password } = values;

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();
    await createUser(values).unwrap();
    navigate("/verify", { state: { email } });
  };

  return (
    <Container maxWidth="sm">
      <Card>
        <CardContent>
          <Box textAlign="center" pb={2}>
            <IconButton onClick={() => navigate("/")}>
              <LogoIcon color="primary" sx={{ fontSize: "8rem" }} />
            </IconButton>
            <Typography variant="h5" gutterBottom>
              Sign up with email
            </Typography>
          </Box>
          <Box component="form" onSubmit={handleSubmit}>
            <List>
              <ListItem>
                <TextField
                  label="Name"
                  name="name"
                  type="text"
                  value={name}
                  onChange={handleChange}
                  fullWidth
                  disabled={isLoading}
                  required
                />
              </ListItem>
              <ListItem>
                <TextField
                  label="Email Address"
                  name="email"
                  type="email"
                  value={email}
                  onChange={handleChange}
                  fullWidth
                  disabled={isLoading}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email />
                      </InputAdornment>
                    ),
                  }}
                />
              </ListItem>
              <ListItem>
                <TextField
                  label="Password"
                  name="password"
                  type="password"
                  value={password}
                  onChange={handleChange}
                  fullWidth
                  disabled={isLoading}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    ),
                  }}
                />
              </ListItem>
              <ListItem>
                <Button type="submit" fullWidth variant="contained" size="large">
                  Sign up
                </Button>
              </ListItem>
            </List>

            <Typography align="center" variant="body2">
              Already have an account? <Link href="/login">Log in</Link>
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Typography variant="caption" component="p" sx={{ position: "absolute", bottom: 0 }}>
        By signing up, you are agreeing to our <Link href="/">terms of service</Link>
      </Typography>
    </Container>
  );
};

export default Signup;
